import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
  assetWithoutCollectionModelFactory,
  AssetWithoutCollectionResponse,
} from "../workflow/deployment/device-without-collection.model";
import {map} from "rxjs/operators";
import {toList} from "../helpers/helpers";

@Injectable()
export class UsageCollectionsService {
  private url: string = "/api/usage-collections";

  constructor(private http: HttpClient) {
  }

  getAssets(deploymentId: string): Promise<AssetWithoutCollectionResponse> {
    return this.http.get<AssetWithoutCollectionResponse>(`${this.url}/list-assets`, {params: {deploymentId}})
      .pipe(
        map(json => ({
          message: json.message,
          assetsWithoutCollections: toList(assetWithoutCollectionModelFactory, json.assetsWithoutCollections),
        })),
      )
      .toPromise();
  }
}
